import { render, staticRenderFns } from "./editUser.vue?vue&type=template&id=25a42868&scoped=true&"
import script from "./editUser.vue?vue&type=script&lang=js&"
export * from "./editUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a42868",
  null
  
)

export default component.exports